import _ from "lodash";
import React, { useEffect, useState } from "react";

import { useRootStore } from "store";
import OverlayLoader from "components/loader/OverlayLoader";
import { Entry } from "models/inventory/inventory";
import InventoryList from "../components/inventoryList/InventoryList";
import InventoryTable from "../components/inventoryTable/InventoryTable";
import { useRequiredCustomerId } from "hooks/use-customer-id";

export default function InventoryExternalUser() {
  const customerId = useRequiredCustomerId();
  const {
    user,
    inventory: inventoryState
  } = useRootStore((store) => store);

  const {
    articleRegister,
    inventory,
    isCreatingInventoryPdf,
    isLoadingArticleRegister,
    isLoadingInventories,
    isLoadingInventory,
    isSavingInventory,
    isUpdatingInventory,
    clearInventory,
    getArticleRegister,
    getInventories,
    updateInventory,
    createInventoryPdf,
    getInventory
  } = inventoryState;

  const { customerName } = useRootStore(
    (state) => state.customers.workingCustomer
  );

  const username = `${user.userInfo?.givenName} ${user.userInfo?.surName}`;
  const isInventoryEmpty = _.isEmpty(inventory);
  const isArticleRegisterEmpty = _.isEmpty(articleRegister);

  const [selectedInventory, setSelectedInventory] = useState(0);

  useEffect(() => {
    clearInventory();
    if (_.isEmpty(articleRegister)) {
      getArticleRegister();
    }
    getInventories(customerId);
  }, [customerId, clearInventory, articleRegister, getArticleRegister, getInventories]);

  const handleGoBack = () => {
    setSelectedInventory(0);
    clearInventory();
    getInventories(customerId);
  };

  const handleInventoryComplete = (inventoryEntries: Entry[]) => {
    updateInventory(
      customerId,
      selectedInventory,
      inventoryEntries,
      "completed"
    );
  };

  const handleInventoryCreatePdf = (inventoryId: number) => {
    createInventoryPdf(
      customerId,
      inventoryId,
      customerName,
      username
    );
  };

  const handleInventoryOpen = (
    inventoryId: number,
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();
    setSelectedInventory(inventoryId);
    getInventory(customerId, inventoryId);
  };

  const handleInventorySave = (inventoryEntries: Entry[]) => {
    updateInventory(
      customerId,
      selectedInventory,
      inventoryEntries,
      "ongoing"
    );
  };

  return (
    <div>
      <OverlayLoader
        isLoading={
          isLoadingArticleRegister ||
          isCreatingInventoryPdf ||
          isLoadingInventories ||
          isLoadingInventory ||
          isSavingInventory ||
          isUpdatingInventory
        }
      >
        <>
          {isInventoryEmpty && (
            <InventoryList
              onInventoryCreatePdf={handleInventoryCreatePdf}
              onInventoryOpen={handleInventoryOpen}
            />
          )}

          {!isInventoryEmpty && !isArticleRegisterEmpty && (
            <InventoryTable
              isInternalUser={false}
              onGoBack={handleGoBack}
              onInventoryComplete={handleInventoryComplete}
              onInventorySave={handleInventorySave}
            />
          )}

          {!isInventoryEmpty && isArticleRegisterEmpty && (
            <p>Inladdning av artiklar misslyckades. Pröva igen senare.</p>
          )}
        </>
      </OverlayLoader>
    </div>
  );
}
